<template>
    
        <b-row align-h="around">
            <b-col sm="12">
                <div>
                    <div id="croppie-div"></div>
                </div>
            </b-col>
            <b-col>
                &nbsp;&nbsp;<b-button variant="secondary" @click="cancelar()">Cancelar</b-button>
            </b-col>
            <b-col class="text-right">
                <b-button variant="primary" @click="guardar()">Guardar</b-button>&nbsp;&nbsp;
            </b-col>

        </b-row>
    
</template>

<script>

import Croppie from 'croppie'

export default {
    props:['img','div','width','height'],
    data(){
        return {
            image : null,
            croppie: null
        }
    },
    mounted(){
        this.image = this.img;
        this.setUp();
    },
    methods:{
        setUp(){
            let el = document.getElementById('croppie-div');
            this.croppie = new Croppie(el,{
                viewport: { width: this.width, height: this.height },
                boundary: { width: this.width+50, height: this.height+50 },
                showZoomer: false,
                enableOrientation: true,
                enableZoom: true
            });
            this.croppie.bind({
                url: this.image
            });
        },
        guardar(){
            this.croppie.result('blob')
                .then(file =>{
                    this.$emit('guardar',file)
                    //console.log(file);
                })
        },
        cancelar(){
            this.$emit('cancelar');
        }
    }
}
</script>

<style lang="scss">
  .Image-upload {
    .Modal {
      border-top: 1px solid #f4f4f4;
      margin-top: 10px;
      h4 {
        margin-bottom: 20px;
      }
    }
    div#upload-wrapper {
      text-align: center;
    }
    .input-file {
      text-align: left;
      width: 50%;
      margin: 0px auto;
      margin-bottom: 20px;
    }
  }

  .cr-slider{
      display: inline !important;
  }
</style>